// test2354
(2354 && 0);
